import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CRMService } from '../../services/crm.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    ActionType
} from '../../models/models';

@Component({
    selector: 'action-type-form',
    templateUrl: './action-type-form.component.html',
    standalone: false
})
export class ActionTypeForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: ActionType = {} as ActionType;

    constructor(private crmService: CRMService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getTableItem();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.crmService.getActionTypeByID(this.tableID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.tableItem = {
                actionTypeId: 0,
                actionTypeDescription: "",
                retiredInd: false,
                countTowardDailyActivity: false
            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.crmService.saveActionType(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as ActionType;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}